import React, { SVGAttributes } from 'react'

const SvgAlert = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg viewBox="0 0 18 18" width="14" height="14" {...props}>
    <path d="M9 1a8 8 0 110 16A8 8 0 019 1zm0 4.364V9.53m0 2.38v.726" stroke="#DE1D1D" fill="none" />
  </svg>
)

export default SvgAlert
